import { render } from "./PannelComponent.vue?vue&type=template&id=8cc07f6c&scoped=true"
import script from "./PannelComponent.vue?vue&type=script&lang=js"
export * from "./PannelComponent.vue?vue&type=script&lang=js"

import "./PannelComponent.vue?vue&type=style&index=0&id=8cc07f6c&lang=css"
import "./PannelComponent.vue?vue&type=style&index=1&id=8cc07f6c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc07f6c"]])

export default __exports__